import React from 'react';
import moment from 'moment';
import { getNumberFormat, getDollarFormat } from 'utils/helpers';
import NoDataMsg from 'library/noData';


const Body = ({ endOfDay, beginDate, endDate }) => (
    <React.Fragment>
        {
            endOfDay.length <= 0 ?
                //If there's NO DATA to display
                <NoDataMsg />
                :
                //If there's DATA
                <div>
                    <div className="text-center list_header">
                        {beginDate ?
                            <p><i>From</i> <b>{moment(beginDate).format('MMMM Do, YYYY')}</b> <i> to </i>
                                {endDate ? <b>{moment(endDate).format('MMMM Do, YYYY')}</b> : moment().format('MMMM Do, YYYY')}</p>
                            : ""}
                    </div>
                    <table className="table table-striped table-hover ">
                        <thead>
                            <tr>
                                <th id="end-of-day-header">
                                    Information
                                </th>
                                <th id="end-of-day-header">
                                    Detail
                                </th>
                            </tr>
                        </thead>
                        <tbody id="end-of-day-body">
                            <tr>
                                <td><strong>Net Sales</strong></td>
                                <td>{getDollarFormat(endOfDay.netSales)}</td>
                            </tr>
                            <tr>
                                <td><strong>Gross Sales</strong></td>
                                <td>{getDollarFormat(endOfDay.grossSales)}</td>
                            </tr>
                            <tr>
                                <td><strong>Total Discount</strong></td>
                                <td>{getDollarFormat(endOfDay.totalDiscountAmount)}</td>
                            </tr>
                            <tr>
                                <td><strong>Total Refund Amount (Non-Including Tax)</strong></td>
                                <td>{getDollarFormat(endOfDay.totalRefundAmountNonIncludingTax)}</td>
                            </tr>
                            <tr>
                                <td><strong>Total Tax</strong></td>
                                <td>{getDollarFormat(endOfDay.totalTax)}</td>
                            </tr>
                            <tr>
                                <td><strong>Total Deposit Amount</strong></td>
                                <td>{getDollarFormat(endOfDay.totalDepositAmount)}</td>
                            </tr>
                            <tr>
                                <td><strong>Transaction Average (Only Completed & Partially Refunded Orders are counted)</strong></td>
                                <td>{getDollarFormat(endOfDay.transactionAverage)}</td>
                            </tr>
                            <tr>
                                <td><strong>Total Cost (COGS) (Calculated From Exact Cost)</strong></td>
                                <td>{getDollarFormat(endOfDay.totalCostExact)}</td>
                            </tr>
                            <tr>
                                <td><strong>Gross Profit (Calculated From Exact Cost)</strong></td>
                                <td>{getDollarFormat(endOfDay.grossProfitExact)}</td>
                            </tr>
                            <tr>
                                <td><strong>Total Cost (COGS) (Calculated From WAC)</strong></td>
                                <td>{getDollarFormat(endOfDay.totalWAC)}</td>
                            </tr>
                            <tr>
                                <td><strong>Gross Profit (Calculated From WAC)</strong></td>
                                <td>{getDollarFormat(endOfDay.grossProfitWAC)}</td>
                            </tr>
                            <tr>
                                <td><strong>Total Penny Adjust Amount</strong></td>
                                <td>{getDollarFormat(endOfDay.totalPennyAdjustAmount)}</td>
                            </tr>
                            <tr>
                                <td><strong># of Invoice Sold (Only Completed & Partially Refunded Orders)</strong></td>
                                <td>{getNumberFormat(endOfDay.invoiceSold)}</td>
                            </tr>
                            <tr>
                                <td><strong># of Invoice Refunded (Refunded & Partially Refunded Orders are counted)</strong></td>
                                <td>{getNumberFormat(endOfDay.invoiceRefunded)}</td>
                            </tr>
                            <tr>
                                <td><strong>Invoice Net Sold (# of Invoice Sold - # of Invoice Refunded)</strong></td>
                                <td>{getNumberFormat(endOfDay.inoviceNetSold)}</td>
                            </tr>
                            <tr>
                                <td><strong>Total Refund Amount (Including Tax)</strong></td>
                                <td>{getDollarFormat(endOfDay.totalRefundAmountIncludingTax)}</td>
                            </tr>
                            <tr>
                                <td><strong># of Items Sold</strong></td>
                                <td>{getNumberFormat(endOfDay.itemSold)}</td>
                            </tr>
                            <tr>
                                <td><strong># of Items Refunded</strong></td>
                                <td>{getNumberFormat(endOfDay.itemRefund)}</td>
                            </tr>
                            <tr>
                                <td><strong># of Item Net Sold (# of Items Sold - # of Items Refunded)</strong></td>
                                <td>{getNumberFormat(endOfDay.itemNetSold)}</td>
                            </tr>
                            <tr>
                                <td><strong>Gift Card Sales</strong></td>
                                <td>{getDollarFormat(endOfDay.giftCardSales)}</td>
                            </tr>
                            <tr>
                                <td><strong>Gift Card Refunds</strong></td>
                                <td>{getDollarFormat(endOfDay.giftCardRefunds)}</td>
                            </tr>
                            <tr>
                                <td><strong>Gift Card Discounts</strong></td>
                                <td>{getDollarFormat(endOfDay.giftCardDiscounts)}</td>
                            </tr>
                            <tr>
                                <td><strong>Tip Amount</strong></td>
                                <td>{getDollarFormat(endOfDay.tipAmount)}</td>
                            </tr>
                        </tbody>
                    </table>
                    <div className="row m-0">
                        <div className="col-lg-4">
                            <table className="table table-striped">
                                <thead>
                                    <tr>
                                        <th className='tableHeaderColorGray'>Product – Main Category </th>
                                        <th className='tableHeaderColorGray text-center'>Gross Sales</th>
                                        <th className='tableHeaderColorGray text-center'>Net Sales</th>
                                    </tr>
                                </thead>
                                <tbody className="purpleTextTableReport">
                                    {
                                        endOfDay.endOfDayMainCategorySales ? endOfDay.endOfDayMainCategorySales.map((item, index) => {
                                            return (
                                                <tr key={index}>
                                                    <td className={item.name == "All" ? 'table-view-title' : ""}>{item.name}</td>
                                                    <td className={item.name == "All" ? 'text-center table-view-title' : 'text-center'}>{getDollarFormat(item.grossSales)}</td>
                                                    <td className={item.name == "All" ? 'text-center table-view-title' : 'text-center'}>{getDollarFormat(item.amount)}</td>
                                                </tr>
                                            )
                                        }) : <p></p>
                                    }
                                </tbody>
                            </table>
                            <table className="table table-striped">
                                <thead>
                                    <tr>
                                        <th className='tableHeaderColorGray'>Product – Sub Category</th>
                                        <th className='tableHeaderColorGray text-center'>Gross Sales</th>
                                        <th className='tableHeaderColorGray text-center'>Net Sales</th>
                                    </tr>
                                </thead>
                                <tbody className="purpleTextTableReport">
                                    {
                                        endOfDay.endOfDayCategorySales ? endOfDay.endOfDayCategorySales.map((item, index) => {
                                            return (
                                                <tr key={index}>
                                                    <td className={item.name == "All" ? 'table-view-title' : ""}>{item.name}</td>
                                                    <td className={item.name == "All" ? 'text-center table-view-title' : 'text-center'}>{getDollarFormat(item.grossSales)}</td>
                                                    <td className={item.name == "All" ? 'text-center table-view-title' : 'text-center'}>{getDollarFormat(item.amount)}</td>
                                                </tr>
                                            )
                                        }) : <p></p>
                                    }
                                </tbody>
                            </table>
                        </div>
                        <div className="col-lg-4">
                            <table className="table table-striped">
                                <thead>
                                    <tr>
                                        <th className='tableHeaderColorGray'>Tax</th>
                                        <th className='tableHeaderColorGray text-center'>Amount</th>
                                    </tr>
                                </thead>
                                <tbody className="purpleTextTableReport">
                                    {
                                        endOfDay.endOfDayTaxes ? endOfDay.endOfDayTaxes.map((item, index) => {
                                            return (
                                                <tr key={index}>
                                                    <td className={item.method == "All" ? 'table-view-title' : ""}>{item.method}</td>
                                                    <td className={item.method == "All" ? 'text-center table-view-title' : 'text-center'}>{getDollarFormat(item.amount)}</td>
                                                </tr>
                                            )
                                        }) : <p></p>
                                    }
                                </tbody>
                            </table>
                            <table className="table table-striped">
                                <thead>
                                    <tr>
                                        <th className='tableHeaderColorGray'>Discount</th>
                                        <th className='tableHeaderColorGray text-center'>Amount</th>
                                    </tr>
                                </thead>
                                <tbody className="purpleTextTableReport">
                                    {
                                        endOfDay.endOfDayDiscounts ? endOfDay.endOfDayDiscounts.map((item, index) => {
                                            return (
                                                <tr key={index}>
                                                    <td className={item.name == "All" ? 'table-view-title' : ""}>{item.name}</td>
                                                    <td className={item.name == "All" ? 'text-center table-view-title' : 'text-center'}>{getDollarFormat(item.amount)}</td>
                                                </tr>
                                            )
                                        }) : <p></p>
                                    }
                                </tbody>
                            </table>
                        </div>
                        <div className="col-lg-4">
                            <table className="table table-striped">
                                <thead>
                                    <tr>
                                        <th className='tableHeaderColorGray'>Payment Method (Excluding Tip, In-Store and Online)</th>
                                        <th className='tableHeaderColorGray text-center'>Amount</th>
                                    </tr>
                                </thead>
                                <tbody className="purpleTextTableReport">
                                    {
                                        endOfDay.paymentMethods ? endOfDay.paymentMethods.map((item, index) => {
                                            return (
                                                <tr key={index}>
                                                    <td className={item.method == "All" ? 'table-view-title' : ""}>{item.method}</td>
                                                    <td className={item.method == "All" ? 'text-center table-view-title' : 'text-center'}>{getDollarFormat(item.amount)}</td>
                                                </tr>
                                            )
                                        }) : <p></p>
                                    }
                                </tbody>
                            </table>
                            <table className="table table-striped">
                                <thead>
                                    <tr>
                                        <th className='tableHeaderColorGray'>Payment Method (In-Store Only)</th>
                                        <th className='tableHeaderColorGray text-center'>Amount</th>
                                    </tr>
                                </thead>
                                <tbody className="purpleTextTableReport">
                                    {
                                        endOfDay.onlineCardPaymentMedthods ? endOfDay.inStorePaymentMedthods.map((item, index) => {
                                            return (
                                                <tr key={index}>
                                                    <td className={item.method == "All" ? 'table-view-title' : ""}>{item.method}</td>
                                                    <td className={item.method == "All" ? 'text-center table-view-title' : 'text-center'}>{getDollarFormat(item.amount)}</td>
                                                </tr>
                                            )
                                        }) : <p></p>
                                    }
                                </tbody>
                            </table>
                            <table className="table table-striped">
                                <thead>
                                    <tr>
                                        <th className='tableHeaderColorGray'>Payment Method (Online Only)</th>
                                        <th className='tableHeaderColorGray text-center'>Amount</th>
                                    </tr>
                                </thead>
                                <tbody className="purpleTextTableReport">
                                    {
                                        endOfDay.onlineCardPaymentMedthods ? endOfDay.onlineCardPaymentMedthods.map((item, index) => {
                                            return (
                                                <tr key={index}>
                                                    <td className={item.method == "All" ? 'table-view-title' : ""}>{item.method}</td>
                                                    <td className={item.method == "All" ? 'text-center table-view-title' : 'text-center'}>{getDollarFormat(item.amount)}</td>
                                                </tr>
                                            )
                                        }) : <p></p>
                                    }
                                </tbody>
                            </table>
                            <table className="table table-striped">
                                <thead>
                                    <tr>
                                        <th className='tableHeaderColorGray'>Tip Amount</th>
                                        <th className='tableHeaderColorGray text-center'>Amount</th>
                                    </tr>
                                </thead>
                                <tbody className="purpleTextTableReport">
                                    {
                                        endOfDay.tipMethods ? endOfDay.tipMethods.map((item, index) => {
                                            return (
                                                <tr key={index}>
                                                    <td className={item.method == "All" ? 'table-view-title' : ""}>{item.method}</td>
                                                    <td className={item.method == "All" ? 'text-center table-view-title' : 'text-center'}>{getDollarFormat(item.amount)}</td>
                                                </tr>
                                            )
                                        }) : <p></p>
                                    }
                                </tbody>
                            </table>
                            <table className="table table-striped">
                                <thead>
                                    <tr>
                                        <th className='tableHeaderColorGray'>Refund Method</th>
                                        <th className='tableHeaderColorGray text-center'>Amount</th>
                                    </tr>
                                </thead>
                                <tbody className="purpleTextTableReport">
                                    {
                                        endOfDay.refundMethods ? endOfDay.refundMethods.map((item, index) => {
                                            return (
                                                <tr key={index}>
                                                    <td className={item.method == "All" ? 'table-view-title' : ""}>{item.method}</td>
                                                    <td className={item.method == "All" ? 'text-center table-view-title' : 'text-center'}>{getDollarFormat(item.amount)}</td>
                                                </tr>
                                            )
                                        }) : <p></p>
                                    }
                                </tbody>
                            </table>
                        </div>
                        <div className="col-lg-12">
                            <table className="table table-striped table-hover">
                                <thead>
                                    <tr>
                                        <th className='tableHeaderColorGray'>Name</th>
                                        <th className='tableHeaderColorGray text-center'># of Invoice Sold</th>
                                        <th className='tableHeaderColorGray text-center'>Total Amount (Including Tax)</th>
                                        <th className='tableHeaderColorGray text-center'>Net Sales</th>
                                        <th className='tableHeaderColorGray text-center'># of Invoice Refunded</th>
                                        <th className='tableHeaderColorGray text-center'>Total Refund Amount (Including Tax)</th>
                                        <th className='tableHeaderColorGray text-center'>Average Refund Amount</th>
                                        <th className='tableHeaderColorGray text-center'>Average Sale Amount</th>
                                    </tr>
                                </thead>
                                <tbody className="purpleTextTableReport">
                                    {
                                        endOfDay.endOfDayEmployees ? endOfDay.endOfDayEmployees.map((item, index) => {
                                            return (
                                                <tr key={index}>
                                                    <td className={item.name == "All" ? 'table-view-title' : ''}>{item.name}</td>
                                                    <td className={item.name == "All" ? 'table-view-title text-center' : 'text-center'}>{item.salesNumber}</td>
                                                    <td className={item.name == "All" ? 'table-view-title text-center' : 'text-center'}>{getDollarFormat(item.totalInvoiced)}</td>
                                                    <td className={item.name == "All" ? 'table-view-title text-center' : 'text-center'}>{getDollarFormat(item.salesTotalAmount)}</td>
                                                    <td className={item.name == "All" ? 'table-view-title text-center' : 'text-center'}>{item.refundNumber}</td>
                                                    <td className={item.name == "All" ? 'table-view-title text-center' : 'text-center'}>{getDollarFormat(item.refundTotalAmount)}</td>
                                                    <td className={item.name == "All" ? 'table-view-title text-center' : 'text-center'}>{getDollarFormat(item.averageRefundAmount)}</td>
                                                    <td className={item.name == "All" ? 'table-view-title text-center' : 'text-center'}>{getDollarFormat(item.averageSaleAmount)}</td>
                                                </tr>
                                            )
                                        }) : <tr></tr>
                                    }
                                </tbody>
                            </table>

                        </div>


                    </div>
                </div>

        }
    </React.Fragment>
);
export default Body;
